import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";

export type PositionTableHeaderProps = {
    PqeAndExpView: boolean,
    PqeView: boolean,
    ExpView: boolean,
    RefView: boolean,
    PracticeGroupView: boolean,
    totalCols: number,
}
export function PositionTableHeader(props: PositionTableHeaderProps) {
    const app = useContext(AppContext);

    return (<>
        <tr>
            <th><i className="fa-solid fa-briefcase me-1"></i> Job Title</th>
            <th><i className="fa-solid fa-building-columns me-1"></i> {app.positions?.Features.DisplayText_Department}</th>
            {props.PracticeGroupView && <th><i className="fa-solid fa-people-group me-1"></i> {app.positions?.Features.DisplayText_PracticeGroup}</th>}
            <th><i className="fa-solid fa-location-dot me-1"></i> Location</th>
            {props.PqeAndExpView && <th><i className="fa-solid fa-lightbulb me-1"></i> PQE / Experience</th>}
            {props.PqeView && <th><i className="fa-solid fa-lightbulb me-1"></i> PQE</th>}
            {props.ExpView && <th><i className="fa-solid fa-lightbulb me-1"></i> Experience</th>}
            {props.RefView && <th title={`Reference`}><i title={`Reference`} className="fa-solid fa-hashtag me-1"></i> Ref</th>}
        </tr>
    </>);
}